// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase config from .env
const firebaseConfig = {
  apiKey: "AIzaSyCxVIYQtI-qxSiq1OKGDAHgTASqiNJbefQ",
  authDomain: "notify-38b31.firebaseapp.com",
  projectId: "notify-38b31",
  storageBucket: "notify-38b31.firebasestorage.app",
  messagingSenderId: "648993315957",
  appId: "1:648993315957:web:f754e15434eaa6f1aeac3c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const messaging = getMessaging(app);

// Function to request FCM token
const requestForToken = async () => {
  try {
    console.log("Requesting notification permission...");
    const permission = await Notification.requestPermission();
    console.log("Permission status:", permission);

    if (permission === 'granted') {
      console.log("Permission granted. Requesting token...");
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      });
      if (token) {
        console.log("FCM Token:", token);
        return token;
      } else {
        console.warn("No token available.");
        return null;
      }
    } else {
      console.warn("Permission not granted for notifications.");
      return null;
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    if (error.code === 'messaging/failed-service-worker-registration') {
      console.error("Service worker registration failed. Check SSL certificate.");
    }
    return null;
  }
};

// Optional: listener for foreground messages
const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// Exports
export {
  auth,
  db,
  storage,
  messaging,
  requestForToken,
  onMessageListener,
};
